module.exports = __webpack_public_path__ + "img/16.c6270b9d.png";